import NavigationBar from "../navigation/nav-bar/navigationBar";
import FooterComponent from "../navigation/footer/footerComponent";

const sections = [
    {
        title: "Use of information.",
        body: "Personal information shared on this website, such as submitting forms to Admissions, will only be used by EA to conduct official academy business. Personal information will never be disseminated to any unaffiliated third party.",
    },
    {
        title: "Security and photos.",
        body: "The Academy is committed to ensuring the safety of the website and its users. This site has security measures in place to protect all information under our control. Use of photographs on the EA website and social media sites photographs of EA community members, including students, alumni, faculty, and staff are used on this web site. EA respects the privacy of every constituent who accesses our website and social media properties, including but not exclusive to our accounts on Facebook, Instagram, and LinkedIn.",
    },
    {
        title: "Community images.",
        body: "EA occasionally posts images on the website or on social media sites of community members – in particular, current students, teachers and alumni. We do not post, or permit constituents to post images that might be deemed inappropriate.",
    },
    {
        title: "Image removal.",
        body: "We will honor all requests by users who wish to have images of themselves removed from the website or social media sites. To make such a request, please contact contact@externacademy.com.",
    },
    {
        title: "Materials posted online.",
        body: "Please be aware Extern Academy has no control over materials once they are posted online, and these can be copied or sent without our knowledge or permission.",
    },
    {
        title: "Copyright.",
        body: "All materials on this site are copyrighted by EA unless otherwise indicated. EA will not post copyrighted material without written permission from the appropriate parties.",
    },
    {
        title: "External links.",
        body: "EA provides links to other websites or resources. We do not control these sites and resources, do not endorse them, and are not responsible for their availability, content, or delivery of services. In particular, external sites are not bound by EA's privacy policy.",
    },
];

export default function PrivacyPolicy() {
    return (
        <div>
            <NavigationBar />

            {/* Hero */}
            <div className="bg-gray-200 py-5">
                <div className="container py-5">
                    <nav className="mb-4">
                        <span style={{ fontSize: "0.7rem", letterSpacing: "0.18em", textTransform: "uppercase", color: "rgba(0,0,0,0.35)" }}>
                            <a href="/" style={{ color: "rgba(0,0,0,0.35)", textDecoration: "none" }}>Home</a>
                            {" · "}Privacy Policy
                        </span>
                    </nav>
                    <p style={{ fontSize: "0.7rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "#D23C1E", marginBottom: "1rem" }}>
                        Legal
                    </p>
                    <h1 className="fw-bold mb-4" style={{ fontSize: "clamp(2.5rem, 7vw, 5rem)", lineHeight: 1.05 }}>
                        Privacy Policy
                    </h1>
                    <p style={{ color: "#6b7280", maxWidth: 480, fontSize: "1.05rem", lineHeight: 1.75, margin: 0 }}>
                        What we collect and what we do with it.
                    </p>
                </div>
            </div>

            {/* Policy sections */}
            <main role="main">
                <div className="container py-16" style={{ maxWidth: 780 }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "3rem" }}>
                        {sections.map(({ title, body }, i) => (
                            <div key={i} style={{ borderLeft: "3px solid #D23C1E", paddingLeft: "1.75rem" }}>
                                <h2 className="fw-bold mb-3" style={{ fontSize: "clamp(1.1rem, 2.5vw, 1.4rem)" }}>
                                    {title}
                                </h2>
                                <p style={{ color: "#4b5563", lineHeight: 1.8, margin: 0 }}>
                                    {body}
                                    {title === "Photos and community members." && (
                                        <>
                                            {" "}
                                            <a href="mailto:contact@externacademy.com" style={{ color: "#D23C1E" }}>
                                                contact@externacademy.com
                                            </a>
                                            .
                                        </>
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Contact callout */}
                    <div className="mt-16 p-5 rounded-lg" style={{ background: "#f9fafb", border: "1px solid #e5e7eb" }}>
                        <h3 className="fw-bold mb-2" style={{ fontSize: "1.1rem" }}>Questions about this policy?</h3>
                        <p style={{ color: "#6b7280", marginBottom: "1rem" }}>
                            Contact us at <a href="mailto:contact@externacademy.com" style={{ color: "#D23C1E" }}>contact@externacademy.com</a>.
                        </p>
                    </div>
                </div>
            </main>

            <FooterComponent />
        </div>
    );
}
